<template>
  <v-card elevation="0" class="pa-2">
    <v-card-title>
      <strong v-if="categoryId">Editar categoria</strong>
      <strong v-else>Cadastrar categoria</strong>
    </v-card-title>
    <v-form ref="courseForm" v-model="courseForm" lazy-validation>
      <v-row cols="12" class="ma-0">
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <label>Nome</label>
          <v-text-field
              outlined
              placeholder="Nome do curso"
              v-model="category.name"
              attach
              dense
              clearable
              :rules="[rules.required]"
              color="#000000"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12">
          <span class="label-details">Descrição</span>
          <quill-editor
              :content="category.descriptionHtml"
              @change="onEditorChange($event)"
              ref="myQuill"
          >
          </quill-editor>
        </v-col>
      </v-row>

      <v-row class="d-flex justify-center pt-0 ma-0 pa-0">
        <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
          <v-btn
              elevation="0"
              class="secondary-button"
              width="100%"
              @click="close()"
          >
            <span>Fachar</span>
          </v-btn>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
          <v-btn
              elevation="0"
              class="primary-button"
              width="100%"
              @click="submit()"
          >
            <span v-if="categoryId">Editar categoria</span>
            <span v-else>Cadastrar categoria</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";

export default {
  name: "Category",
  components: { },
  computed: {},

  props: {
    categoryId: {type: Number, required: false, default: null}
  },

  created() {
  },

  async mounted() {
    if (this.categoryId) {
      this.category = {
        name: null,
        descriptionHtml: null,
      }
      await this.getCategoryCourses()
    }
  },
  data() {
    return {
      selectedCourse: [],
      dialogDetailCourse: false,
      currentCourse: Object,
      outlined: true,
      options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 11,
        precision: 2,
        max: 10
      },
      category: {
        name: null,
        descriptionHtml: null,
      },
      courses: [],
      courseForm: false,
      apiService: new ApiService(),
      rules: {
        required: (value) => !!value || "Campo requerido.",
      }
    };
  },

  methods: {
    async getCategoryCourses() {
      try {
        const {content} = await this.apiService.get(`categoryCourses/${this.categoryId}`,)
        this.category = content
      } catch (e) {

      }
    },


    async goToRoute(route) {
      await this.$router.push(route);
    },

    async submit() {
      try {
        if (!this.$refs.courseForm.validate()) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Preencha os campos corretamente",
            trace: null,
          });
          return
        }

        let message = ''
        let statusCode = null

        if (this.categoryId) {
          const response = await this.apiService.put(`categoryCourses/${this.categoryId}`, this.category, false)
          message = response.message
          statusCode = response.statusCode
        } else {
          const response = await this.apiService.post("categoryCourses", this.category, false)
          message = response.message
          statusCode = response.statusCode
        }
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "success",
          title: message,
          message: message,
          trace: null,
        });
        if (statusCode == 200) {
          this.$refs.courseForm.reset()          // limpa todos os campos
          this.$refs.courseForm.resetValidation()
          this.selectedCourse = []
          this.close()
        }

      } catch (e) {

      }
    },

    close() {
      this.$emit('close')
      this.$emit('reload')
    },
    onEditorChange({quill, html, text}) {
      this.category.descriptionHtml = html
    },
  },

  watch: {},
};
</script>

<style lang='scss' scoped>

.title-toolbar {
  font-size: 19px;
  margin-left: -15px;
  margin-bottom: -2px;
  font-weight: 500;
}

</style>
